module.exports = __webpack_public_path__ + "static/power3-1-7f24f52d34b280fe2bc303d6de1543d5.png";